import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Users, Bath, Images } from 'lucide-react';
import { openWhatsApp, getCabinMessage } from '../utils/whatsapp';
import { CabinGalleryModal } from './CabinGalleryModal';
interface Cabin {
  id: string;
  name: string;
  capacity: string;
  baths?: string;
  description: string;
  images: string[];
}
const cabins: Cabin[] = [{
  id: 'cabana-wara',
  name: 'Cabana y Wara (Gemelas)',
  capacity: 'Para 5 personas c/u',
  baths: '2 baños c/u',
  description: 'Dos cabañas gemelas amplias y cómodas, totalmente independientes. Ideales para disfrutar en familia o con amigos en un entorno natural.',
  images: ['https://cdn.magicpatterns.com/uploads/qQDHYAL69wkKHxj8NjFLBv/CABANA_Y_WARA_EXTERIOR_MEJOR.jpg', 'https://cdn.magicpatterns.com/uploads/deEfvuRLDcpU1fzs3z3hzo/CABANA_Y_WARA_COMEDOR.jpg', 'https://cdn.magicpatterns.com/uploads/mwwGzLdRGrjnRxNHYz9eNv/CABANA_Y_WARA_COCINA_COMEDOR.jpg', 'https://cdn.magicpatterns.com/uploads/bRLiYmtzmnMqhdsRTK6GeB/CABANA_Y_WARA_PLANTA_ALTA.jpg', 'https://cdn.magicpatterns.com/uploads/cdGqJ8ehxM7Vk9KC2V3h1P/CABANA_Y_WARA_ESCALERA.jpg', 'https://cdn.magicpatterns.com/uploads/iSugTXgxM3KB4588t7kHma/CABANA_Y_WARA_DORMITORIO_MATRIMONIO.jpg', 'https://cdn.magicpatterns.com/uploads/wirgsNZpR11xUpPpwg3enk/CABANA_Y_WARA_BANO_PRINCIPAL_1.jpg', 'https://cdn.magicpatterns.com/uploads/eqrRfpgDmjy4KNMJJr6JWB/CABANA_Y_WARA_BANITO.jpg']
}, {
  id: 'tica',
  name: 'Tica',
  capacity: 'Para 2 personas',
  baths: '1 baño',
  description: 'Cálida y acogedora, en una sola planta, perfecta para quienes desean una escapada tranquila en contacto con el paisaje.',
  images: ['https://cdn.magicpatterns.com/uploads/k7FztxA4dSJ8YhQtN7uND9/TICA_FRENTE.jpg', 'https://cdn.magicpatterns.com/uploads/3qNAYWjT1eqcSuhdorDFdQ/TICA_VISTA_2.jpg', 'https://cdn.magicpatterns.com/uploads/sJzNs7FqUuhJSSJcTaz3Pm/TICA_COMEDOR_2.jpg', 'https://cdn.magicpatterns.com/uploads/8Aujr8h1n9riW8Ku6fDBFq/TICA_COCINA.jpg', 'https://cdn.magicpatterns.com/uploads/j5nvhg5BFnRyNrX92rBcGF/TICA_DORMITORIO.jpg', 'https://cdn.magicpatterns.com/uploads/x6qMCtjggJdbJUJUsUtSvS/TICA_VISTA_DESDE_ADENTRO.jpg', 'https://cdn.magicpatterns.com/uploads/oqv1SyTcg3qmYxFugLD87t/TICA_BANO_3_BUENA.jpg']
}, {
  id: 'pirca',
  name: 'Pirca',
  capacity: 'Para 2 a 3 personas',
  baths: '1 baño',
  description: 'Práctica y confortable, ideal para una estadía serena en un entorno natural y cuidado.',
  images: ['https://cdn.magicpatterns.com/uploads/wKCZvwkGMRbhvS62KrSqSp/PIRCA_VISTA_EXTERIOR.jpg', 'https://cdn.magicpatterns.com/uploads/akAC1XtLW7jWcMtfEdPSeq/PIRCA_LIVING_LA_MEJOR.jpg', 'https://cdn.magicpatterns.com/uploads/8Da8wCCs8P1CfNWebaUKdK/PIRCA_COCINA_COMEDOR.jpg', 'https://cdn.magicpatterns.com/uploads/kqS24m1aHdUJwSgCc49qFJ/PIRCA_DORMITORIO.jpg', 'https://cdn.magicpatterns.com/uploads/8zYTEJ8bj5zfuoEJfsU8Qz/PIRCA_BANO.jpg']
}, {
  id: 'inti',
  name: 'Inti',
  capacity: 'Para 4 personas',
  baths: '1 baño',
  description: 'Una cabaña cómoda y funcional, ideal para familias pequeñas o grupos que quieran relajarse y disfrutar del valle.',
  images: ['https://cdn.magicpatterns.com/uploads/9gTBgY7Tw4QLwwYj89vgaw/INTI_FRENTE.jpg', 'https://cdn.magicpatterns.com/uploads/bGc2W5LoLug7UozMAk36Kd/INTI_COMEDOR_A.jpg', 'https://cdn.magicpatterns.com/uploads/7ByirAZkUYN7S2ZkEUUqYw/INTI_AMBIENTE_PRICIPAL_A.jpg', 'https://cdn.magicpatterns.com/uploads/6dzEDtGbHXSnQzDDYyRyZ5/INTI_COMEDOR_CON_CAMA_A.jpg', 'https://cdn.magicpatterns.com/uploads/igmaUFMaEUu1NuiJsi6Aez/INTI_COCINA_A.jpg', 'https://cdn.magicpatterns.com/uploads/w9HTgwKwuQe2Qfi4QHCwL3/INTI_DORMITORIO_LA_MAS_LINDA.jpg', 'https://cdn.magicpatterns.com/uploads/1gVm9gJtevZiorvrZDG7YT/INTI_BANO_A.jpg']
}, {
  id: 'lenin',
  name: 'Lemin',
  capacity: 'Para 2 personas',
  baths: '1 baño',
  description: 'En un entorno serrano, en una sola planta, ideal para disfrutar de la tranquilidad y las vistas del lugar.',
  images: ['https://cdn.magicpatterns.com/uploads/rqTKBB3bATKo8ysszbcpg5/LENIN_DESDE_AFUERA.jpg', 'https://cdn.magicpatterns.com/uploads/21ZzNmPC783wH1cgN9uaF4/LENIN_COMEDOR.jpg', 'https://cdn.magicpatterns.com/uploads/paSY4M2uzYVmBzPzdpvsvG/LENIN_COCINA.jpg', 'https://cdn.magicpatterns.com/uploads/8DV55SUEuegejqXLk7FYwR/LENIN_DORMITORIO.jpg', 'https://cdn.magicpatterns.com/uploads/jJn4hopgWgVxdHApJLUZcs/LENIN_DORMITORIO_3.jpg', 'https://cdn.magicpatterns.com/uploads/gFsMytxVh9imtPZG8QehUS/LENIN_BANO_(2).jpg']
}];
export function Cabins() {
  const [activeCabin, setActiveCabin] = useState<Cabin | null>(null);
  const handleWhatsApp = (cabinName: string) => {
    openWhatsApp(getCabinMessage(cabinName));
  };
  return <section id="cabanas" className="py-24 bg-sand" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-52">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-53">
            Nuestras cabañas
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-54">
            Contamos con seis opciones de alojamiento equipadas para brindar una
            experiencia cómoda y relajante, ideales para parejas, familias o
            grupos que buscan disfrutar del paisaje y la tranquilidad del lugar.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8" data-id="element-55">
          {cabins.map((cabin, index) => {
          const hasGallery = cabin.images.length > 1;
          return <motion.div key={cabin.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 flex flex-col lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-56">
                <button type="button" onClick={() => hasGallery && setActiveCabin(cabin)} className={`relative h-64 overflow-hidden group block w-full text-left ${hasGallery ? 'cursor-pointer' : 'cursor-default'}`} aria-label={hasGallery ? `Ver galería de la cabaña ${cabin.name}` : undefined} tabIndex={hasGallery ? 0 : -1} data-id="element-57">
                  <img src={cabin.images[0]} alt={`Cabaña ${cabin.name}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-58" />
                  {hasGallery && <span className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 bg-charcoal/70 backdrop-blur-sm text-white text-xs font-medium px-3 py-1.5 rounded-full" data-id="element-59">
                      <Images size={14} data-id="element-60" />
                      {cabin.images.length} fotos
                    </span>}
                </button>

                <div className="p-8 flex flex-col flex-grow" data-id="element-61">
                  <h3 className="text-2xl text-olive-dark mb-4" data-id="element-62">
                    {cabin.name}
                  </h3>

                  <div className="flex items-center gap-4 text-sm text-earth mb-4 font-medium" data-id="element-63">
                    <span className="flex items-center gap-1.5 bg-sand-light px-3 py-1 rounded-full" data-id="element-64">
                      <Users size={16} data-id="element-65" /> {cabin.capacity}
                    </span>
                    {cabin.baths && <span className="flex items-center gap-1.5 bg-sand-light px-3 py-1 rounded-full" data-id="element-66">
                        <Bath size={16} data-id="element-67" /> {cabin.baths}
                      </span>}
                  </div>

                  <p className="text-charcoal-light mb-8 flex-grow" data-id="element-68">
                    {cabin.description}
                  </p>

                  <div className="flex flex-col gap-3" data-id="element-69">
                    {hasGallery && <button onClick={() => setActiveCabin(cabin)} className="w-full py-3 inline-flex items-center justify-center gap-2 bg-sand-light text-olive-dark hover:bg-sand rounded-lg font-medium transition-colors" data-id="element-70">
                        <Images size={18} data-id="element-71" />
                        Ver más
                      </button>}
                    <button onClick={() => handleWhatsApp(cabin.name)} className="w-full py-3 border border-olive text-olive hover:bg-olive hover:text-white rounded-lg font-medium transition-colors" data-id="element-72">
                      Consultar disponibilidad
                    </button>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>

      {activeCabin && <CabinGalleryModal cabinName={activeCabin.name} images={activeCabin.images} onClose={() => setActiveCabin(null)} data-id="element-73" />}
    </section>;
}